import styled from 'styled-components';

const HideWhenPrinted = styled.div`
  @media print {
    display: none;
  }
`;
export default HideWhenPrinted;
